<template>
  <b-modal
    id="serialNumberChangeModal"
    size="md"
    content-class="sub-menu-bg-blue-transparent snc-modal"
    title="Update Serial Number"
    hide-footer
    no-fade
    header-close-variant="light"
  >
    <div class="snc-body">

      <!-- Info strip -->
      <div class="snc-info-strip">
        <fa :icon="['fas', 'exchange-alt']" class="snc-info-icon" />
        <span>The current serial number will be replaced with a new one.</span>
      </div>

      <!-- System info card -->
      <div class="snc-info-card">
        <div class="snc-info-row">
          <span class="snc-label">System</span>
          <span class="snc-value">{{ system }}</span>
        </div>
        <div class="snc-info-row">
          <span class="snc-label">Scanner</span>
          <span class="snc-value">{{ scanner }}</span>
        </div>
        <div class="snc-info-row">
          <span class="snc-label">Current SN</span>
          <span class="snc-value">{{ serialNumber }}</span>
        </div>
      </div>

      <!-- New serial number input -->
      <div class="snc-field">
        <label class="snc-field-label">New Serial Number</label>
        <b-form-input
          v-model="newSerialNumber"
          placeholder="Type new serial number..."
          autocomplete="off"
          class="snc-input"
        />
      </div>

      <!-- Actions -->
      <div class="snc-actions">
        <b-button
          class="snc-submit-btn"
          :disabled="!newSerialNumber.trim()"
          @click="submitNewSerialNumber()"
        >
          Update Serial Number
        </b-button>
      </div>

    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
import dpr_update_system from '!!raw-loader!../../../emails/dpr_update_system.html'
export default {
  name: 'MMP_DPR_SerialNumberChange',
  props: ['incomingData', 'user'],
  data() {
    return {
      newSerialNumber: '',
      region: '',
      scanner: 0,
      serialNumber: '',
      system: '',
      systemType: '',
      dpr_update_system_recipients: []
    }
  },
  methods: {
    sendEmail() {
      const fromEmail = 'mmp-info@dmp-maps.com'
      const emailSubject = 'Acquisition System Updated'
      let year = new Date().getFullYear()

      const emailBody = dpr_update_system
              .replace('{{ systemName }}', this.system)
              .replace('{{ scannerNumber }}', this.scanner)
              .replace('{{ region }}', this.region)
              .replace('{{ oldScannerSerial }}', this.serialNumber)
              .replace('{{ newScannerSerial }}', this.newSerialNumber)
              .replace('{{ userName }}', this.user.name)
              .replace('{{ userEmail }}', this.user.email)
              .replace('{{ year }}', year)

      if (sessionStorage.token) {
          axios.post(
                process.env.API_LOCATION + '/api/email/sendemail',
                {
                    fromEmail: fromEmail,
                    toEmail: this.dpr_update_system_recipients,
                    emailSubject: emailSubject,
                    emailBody: emailBody
                },
                {
                    headers: {
                        'x-auth-token': sessionStorage.token
                    }
                }
            ).then(response => {
                const content = response.data
                if (content.errors) {
                    console.log('sendEmail API Call Error')
                } else {
                    if (content.some(obj => obj.status !== 'bounced' || obj.status !== 'rejected')) {
                      this.$bvToast.toast('Email sent.', {
                          autoHideDelay: 5000,
                          variant: 'success',
                          solid: true,
                          title: 'Email Sent',
                          toaster: 'b-toaster-top-center'
                      })
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
                self.feedback = error.response.data.errors[0].msg
                self.showFeedback()
            })
      } else {
        console.log('No User Token')
      }
    },
    submitNewSerialNumber() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/dpr/updateSerialNumber', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              newSerialNumber: this.newSerialNumber.trim(),
              region: this.region,
              scanner: this.scanner,
              serialNumber: this.serialNumber,
              system: this.system,
              system_type: this.systemType
            }
          })
          .then(async (response) => {
            const content = response.data

            if (content.obj.serialNumberAdd) {
              let successCheck =
                content.msg == 'success'
                  ? 'Serial number successfully updated.'
                  : 'Failed to update serial number.'

              this.$bvToast.toast(successCheck, {
                title: 'Serial Number Update',
                toaster: 'b-toaster-top-right'
              })
            }

            // Send Email
            await this.sendEmail()

            this.$emit('updateSystems', content.obj)

            this.newSerialNumber = ''
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getEmailRecipients() {
      if (sessionStorage.token) {
        axios.get(process.env.API_LOCATION + '/api/email/getRecipients', {
          headers: {
            'x-auth-token': sessionStorage.token
          },
          params: {
            module: 'dpr_update_system'
          }
        })
        .then(response => {
          this.dpr_update_system_recipients = response.data[0].recipients;
        })
        .catch(function (error) {
          console.log(error)
        })
      } else {
        console.log('No User Token')
      }
    }
  },
  mounted() {
    this.getEmailRecipients();
  },
  watch: {
    incomingData: function (newValue, oldValue) {
      this.region = this.incomingData.region
      this.scanner = this.incomingData.scanner
      this.serialNumber = this.incomingData.serialNumber
      this.system = this.incomingData.systemName
      this.systemType = this.incomingData.systemType
    }
  }
}
</script>

<style scoped>
.snc-body {
  padding: 4px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* Info strip */
.snc-info-strip {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 13px;
  background: rgba(6, 60, 109, 0.06);
  border: 1px solid rgba(6, 60, 109, 0.2);
  border-left: 3px solid #063c6d;
  border-radius: 6px;
  font-size: 13px;
  color: rgba(6, 60, 109, 0.8);
}
.snc-info-icon {
  color: #063c6d;
  flex-shrink: 0;
}

/* System info card */
.snc-info-card {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px;
  background: rgba(6, 60, 109, 0.04);
  border: 1px solid rgba(6, 60, 109, 0.12);
  border-radius: 6px;
}
.snc-info-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
}
.snc-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(6, 60, 109, 0.6);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  min-width: 80px;
}
.snc-value {
  font-size: 13.5px;
  color: #063c6d;
  font-weight: 500;
}
.snc-value--old {
  color: rgba(6, 60, 109, 0.5);
  font-family: monospace;
  font-size: 13px;
}

/* Input field */
.snc-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.snc-field-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(6, 60, 109, 0.7);
  letter-spacing: 0.07em;
  text-transform: uppercase;
  margin: 0;
}
.snc-input {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
  border-radius: 6px;
  font-size: 13.5px;
}
.snc-input::placeholder { color: rgba(6, 60, 109, 0.35); }
.snc-input:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}

/* Actions */
.snc-actions {
  display: flex;
  justify-content: center;
  padding-top: 4px;
}
.snc-submit-btn {
  background: #063c6d !important;
  border: 1px solid #063c6d !important;
  color: #fff !important;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 6px;
  transition: background 0.15s;
  box-shadow: none !important;
}
.snc-submit-btn:hover:not(:disabled) {
  background: #0a5499 !important;
  border-color: #0a5499 !important;
}
.snc-submit-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>
